import {EnvironmentConfig} from '@src/environments/EnvironmentConfig';
import {EnvironmentNames} from '@src/environments/environments.name';
import {AuthService} from '@src/auth/auth.service';

export const environment: EnvironmentConfig = {
  authServiceType: AuthService,
  clientName: 'oris',
  envName: EnvironmentNames.prod,
  siteKey: '6LelNhAbAAAAAMW6SsL08K3JonExZhfJvfFCYB9C',
  authConfig: {
    // Url of the Identity Provider
    issuer: 'https://owa-auth.oris.ch',
    loginUrl: 'https://owa-auth.oris.ch/authorize',
    postLogoutRedirectUri: 'https://owa.oris.ch',
    // URL of the SPA to redirect the user to after login
    redirectUri: 'https://owa.oris.ch/login',
    silentRefreshRedirectUri: 'https://owa.oris.ch/silent-refresh.html',
    // The SPA's id. The SPA is registerd with this id at the auth-server
    clientId: 'WAS_SPA',
    responseType: 'token',
    // set the scope for the permissions the client should request
    // The first three are defined by OIDC. The 4th is a usecase-specific one
    scope: 'openid profile was roles email',
    oidc: true,
    showDebugInformation: false
  },
  apiBaseUrl: 'https://owa-gw.oris.ch',
  mapBox: {
    appKey: 'pk.eyJ1IjoiZGVubmlzY2FycmVpcmEiLCJhIjoiY2plemh5bWlqMGJyajMzcGRrODJ0MTlkZCJ9.jaEGWDdTSALHzEoJsMszyQ'
  }
};
